export default function QuizLayout({ children, currentIndex, total, onBack }) {
  return (
    <div className="min-h-screen bg-[#efeeea] flex items-center justify-center px-4">
      <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md space-y-4">
        <div className="flex items-center justify-between text-sm text-gray-500">
          <button onClick={onBack} className="text-blue-600 underline">
            戻る
          </button>
          <span>
            {currentIndex + 1} / {total}
          </span>
        </div>
        {children}
      </div>
    </div>
  );
}
